import { createContext } from "react";
import {
  SHOW_HIDE_CART,
  ADD_TO_CART,
  REMOVE_CART_ITEM,
  FILTER_PRODUCTS_BY_BRAND,
} from "./Types";

const storeCartItems = (cartItems) => {
  // const cart = cartItems.length > 0 ? cartItems : [];
  localStorage.setItem("cart", JSON.stringify(cartItems));
};

export const sumItems = (cartItems) => {
  storeCartItems(cartItems);
  return {
    itemCount: cartItems.reduce(
      (total, product) => total + product.quantity,
      0
    ),
    total: cartItems.reduce((a, b) => a + b.price * b.quantity, 0),
  };
};

// export const decreaseItems = (cartItems) => {
//   storeCartItems(cartItems);
//   return {
//     itemCount: cartItems.reduce((total, prod) => total - prod.quantity, 0),
//     total: cartItems.reduce(
//       (total, prod) => total - prod.price * prod.quantity,
//       0
//     ),
//   };
// };

export const CartReducer = (state, action) => {
  switch (action.type) {
    case SHOW_HIDE_CART: {
      return {
        ...state,
        showCart: !state.showCart,
      };
    }
    case ADD_TO_CART: {
      // check if item is in cart
      if (!state.cartItems.find((item) => item.id === action.payload.id)) {
        state.cartItems.push({
          ...action.payload,
          quantity: 1,
        });
      }
      const newCartItems = [...state.cartItems];
      return {
        ...state,
        cartItems: newCartItems,
        ...sumItems(newCartItems),
      };
    }
    case REMOVE_CART_ITEM: {
      const newCartItems = state.cartItems.filter(
        (item) => item.id !== action.payload.id
      );
      return {
        ...state,
        cartItems: [...newCartItems],
        ...sumItems(newCartItems),
      };
    }

    default:
      return state;
  }
};

export const ProductReducer = (state, action) => {
  switch (action.type) {
    case "SORT_BY_PRICE":
      return { ...state, sort: action.payload };
    case "SORT_BY_CATEGORY":
      return { ...state, sort: action.payload };
    case "SORT_BY_SIZE":
      return { ...state, bySize: !state.bySize };
    case "SORT_BY_BRAND":
      return { ...state, byBrand: action.payload };
    case "CLEAR_FILTERS":
      return { byCategory: false, bySize: false, byPrice: 0 };
    case FILTER_PRODUCTS_BY_BRAND:
      return {
        ...state,
        brand: action.payload.brand,
        filteredItems: action.payload.items,
      };
    default:
      return state;
  }
};
